import { FC } from 'react';
import { IAppBarProps } from './types';

const POSITION_CLASS_NAME: Record<NonNullable<IAppBarProps['position']>, string> = {
  fixed: 'fixed top-0 left-0 right-0',
  absolute: 'absolute top-0 left-0 right-0',
  relative: 'relative',
  static: 'static',
  sticky: 'sticky top-0',
};

const VARIANT_CLASS_NAME: Record<NonNullable<IAppBarProps['variant']>, string> = {
  brand: 'app-bar bg-brand text-white shadow-md',
  paper: 'bg-paper text-ash shadow-none',
};

export const AppBar: FC<IAppBarProps> = ({ children, className, position = 'sticky', variant = 'brand' }) => (
  <header
    className={[
      'z-1100 flex w-full shrink-0 flex-col',
      POSITION_CLASS_NAME[position],
      VARIANT_CLASS_NAME[variant],
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {children}
  </header>
);
